import { Link, useParams } from 'react-router-dom'
import { assetUrl } from '../helper_functions/utilities'
import ChampionsMasteredIconWithFallBack from '../shared/ChampionMasteryIcon'
import ProfileIconWithFallback from '../shared/ProfileIcon'

const RecentlyPlayedWith = ({ orderedChampions, recentlyPlayedWith }) => {
    const { displayRegion } = useParams()

    const championNameIdById = {}
    orderedChampions?.forEach((champion) => {
        championNameIdById[parseInt(champion?.champion_id, 10)] = champion?.name_id
    })

    function renderTeammateRow(player, index) {
        const championNameId = championNameIdById[player?.champion_id] || 'Unknown'
        const destination = player?.game_name && player?.tag_line
            ? `/summoners/${displayRegion}/${player.game_name}-${player.tag_line}`
            : null

        const content = (
            <div className="flex min-w-0 items-center gap-2">
                <div className="h-9 w-9 shrink-0">
                    <ProfileIconWithFallback
                        src={assetUrl(`/profile_icons/${player?.profile_icon_id}.png`)}
                        alt={`${player?.game_name} profile icon`}
                    />
                </div>
                <div className="min-w-0 flex-1">
                    <div className="truncate text-xs font-semibold text-zinc-100">
                        {player?.game_name}
                        <span className="ml-1 text-zinc-400">#{player?.tag_line}</span>
                    </div>
                    <div className="mt-0.5 text-[11px] tracking-tight text-zinc-400">
                        {player?.games}G · {player?.wins}W {player?.losses}L
                    </div>
                </div>
                <div className="h-8 w-8 shrink-0 overflow-hidden rounded-full border border-zinc-700 bg-zinc-900">
                    <ChampionsMasteredIconWithFallBack
                        src={assetUrl(`/champion_icons/${championNameId}.png`)}
                        alt={`${championNameId} icon`}
                    />
                </div>
            </div>
        )

        if (!destination) {
            return (
                <article key={index} className="border-b border-zinc-800/80 px-2.5 py-2 first:pt-1 last:border-b-0 last:pb-1">
                    {content}
                </article>
            )
        }

        return (
            <Link
                key={index}
                className="block border-b border-zinc-800/80 px-2.5 py-2 transition-colors first:pt-1 last:border-b-0 last:pb-1 hover:bg-zinc-900/70"
                to={destination}
            >
                {content}
            </Link>
        )
    }

    return (
        <section className="mt-3 rounded-xl border border-zinc-800 bg-zinc-950 px-3 py-4 text-zinc-200 shadow-[0_18px_36px_-28px_rgba(0,0,0,0.95)]">
            <div className="-mx-3 -mt-4 mb-3 border-b border-zinc-800 bg-zinc-900/65 px-3 py-3 text-left">
                <h2 className="text-[10px] font-bold uppercase tracking-[0.14em] text-zinc-500">RECENTLY PLAYED WITH</h2>
            </div>

            {recentlyPlayedWith?.length === 0 ? (
                <div className="rounded-md border border-amber-400/50 bg-amber-300/10 px-3 py-3 text-sm font-medium text-amber-100">
                    No information yet. Try updating.
                </div>
            ) : (
                <div className="space-y-2">
                    {recentlyPlayedWith?.map((player, index) => renderTeammateRow(player, index))}
                </div>
            )}
        </section>
    )
}

export default RecentlyPlayedWith
